export const formatNumber = (number, decimals) => {
  number = Number(number);
  number = number.toFixed(decimals) + '';
  var x = number.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
}

export const createPercentFormatter = (decimals) => {
  return (cell, formatterParams, onRendered) => {
    var content = document.createElement("span");
    var value = cell.getValue();
    var className;
    if (value > 0) {
      className = 'pct_pos';
    } else if (value < 0) {
      className = 'pct_neg';
    } else {
      className = 'pct_zero';
    }
    content.classList.add(className);
    content.innerHTML = formatNumber(value, decimals) + '%';
    return content;
  };
}

export const createDollarFormatter = (decimals) => {
  return (cell, formatterParams, onRendered) => {
    var content = document.createElement("span");
    var value = cell.getValue();
    var className;
    if (value > 0) {
      className = 'dol_pos';
    } else if (value < 0) {
      className = 'dol_neg';
    } else {
      className = 'dol_zero';
    }
    content.classList.add(className);
    content.innerHTML = '$' + formatNumber(value, decimals);
    return content;
  };
}

export const createNumberFormatter = (decimals) => {
  return (cell, formatterParams, onRendered) => {
    var content = document.createElement("span");
    var value = cell.getValue();
    content.innerHTML = formatNumber(value, decimals);
    return content;
  };
}

export const createLinkFormatter = (hrefFn, clickFn) => {
  return (cell) => {
    var value = cell.getValue();
    if (value == null || value === '') return '';
    var content = document.createElement("a");
    content.textContent = value;
    if (hrefFn) {
      content.href = "#" + hrefFn(cell);
    }
    if (clickFn) {
      content.addEventListener("click", (e) => {
        e.preventDefault();
        clickFn(cell);
      });
    }
    return content;
  };
}

export const createLookupFormatter = (lookup) => {
  return (cell, formatterParams, onRendered) => {
    var value = cell.getValue();
    return lookup[value] !== undefined ? lookup[value] : value;
  };
}


export const minMaxFilterFunction = (headerValue, rowValue, rowData, filterParams) => {
  //headerValue - the value of the header filter element
  //rowValue - the value of the column in this row
  //rowData - the data for the row being filtered
  //filterParams - params object passed to the headerFilterFuncParams property
  
  if (rowValue) {
    if (headerValue.start !== "") {
      if (headerValue.end !== "") {
        return rowValue >= headerValue.start && rowValue <= headerValue.end;
      } else {
        return rowValue >= headerValue.start;
      }
    } else {
      if (headerValue.end !== "") {
        return rowValue <= headerValue.end;
      }
    }
  }
  
  return true; //must return a boolean, true if it passes the filter.
}

export const dateRangeFilterEditor = (cell, onRendered, success, cancel, editorParams) => {
  var end;
  var container = document.createElement("span");
  container.style.display = "flex";
  container.style.alignItems = "center";

  var start = document.createElement("input");
  start.setAttribute("type", "date");
  start.style.padding = "4px";
  start.style.flex = "1";
  start.style.minWidth = "0";
  start.style.boxSizing = "border-box";

  var existing = cell.getValue();
  if (existing) {
    start.value = existing.start || "";
  }

  function buildValues(){
    success({
      start:start.value,
      end:end.value,
    });
  }

  function keypress(e){
    if(e.keyCode === 13){
      buildValues();
    }
    if(e.keyCode === 27){
      cancel();
    }
  }

  end = start.cloneNode();
  if (existing) {
    end.value = existing.end || "";
  }

  var clearBtn = document.createElement("button");
  clearBtn.textContent = "\u00d7";
  clearBtn.setAttribute("type", "button");
  clearBtn.style.padding = "2px 6px";
  clearBtn.style.marginLeft = "2px";
  clearBtn.style.cursor = "pointer";
  clearBtn.style.border = "1px solid #ccc";
  clearBtn.style.background = "#fff";
  clearBtn.style.borderRadius = "3px";
  clearBtn.style.lineHeight = "1";
  clearBtn.style.fontSize = "14px";
  clearBtn.addEventListener("click", function(){
    start.value = "";
    end.value = "";
    buildValues();
  });

  start.addEventListener("change", buildValues);
  start.addEventListener("blur", buildValues);
  start.addEventListener("keydown", keypress);

  end.addEventListener("change", buildValues);
  end.addEventListener("blur", buildValues);
  end.addEventListener("keydown", keypress);

  container.appendChild(start);
  container.appendChild(end);
  container.appendChild(clearBtn);

  return container;
}

export const minMaxFilterEditor = (cell, onRendered, success, cancel, editorParams) => {
  var end;
  var container = document.createElement("span");
  
  //create and style inputs
  var start = document.createElement("input");
  start.setAttribute("type", "number");
  start.setAttribute("placeholder", "Min");
  start.setAttribute("min", 0);
  start.setAttribute("max", 100);
  start.style.padding = "4px";
  start.style.width = "50%";
  start.style.boxSizing = "border-box";
  
  start.value = cell.getValue();
  
  function buildValues(){
    success({
      start:start.value,
      end:end.value,
    });
  }
  
  function keypress(e){
    if(e.keyCode === 13){
      buildValues();
    }
    
    if(e.keyCode === 27){
      cancel();
    }
  }
  
  end = start.cloneNode();
  end.setAttribute("placeholder", "Max");
  
  start.addEventListener("change", buildValues);
  start.addEventListener("blur", buildValues);
  start.addEventListener("keydown", keypress);
  
  end.addEventListener("change", buildValues);
  end.addEventListener("blur", buildValues);
  end.addEventListener("keydown", keypress);
  
  container.appendChild(start);
  container.appendChild(end);
  
  return container;
}
